import { OrangeLoader } from '@/components/loaders/OrangeLoader';
import { companySchema, CompanySchema } from '../models/Company';
import { FormTextInput, FormSubmitButton, FormCancelButton } from '@/components';
import useCompanyActions from '../hooks/useCompanyActions';
import { useNavigate, useParams } from 'react-router-dom';
import { zodResolver } from '@hookform/resolvers/zod';
import { useForm } from 'react-hook-form';
import { useEffect } from 'react';
import {
  useGetCompanyQuery,
} from '../services/companies.service';

const EditCompanyForm = () => {
  const { id: companyId } = useParams<{ id: string }>();
  const navigate = useNavigate();

  const { data: company, isLoading: loadingCompany } = useGetCompanyQuery(companyId!);
  const { onUpdate } = useCompanyActions();

  const {
    handleSubmit,
    control,
    reset,
    formState: { isValid, isSubmitting }
  } = useForm<CompanySchema>({
    resolver: zodResolver(companySchema),
    mode: 'onChange',
    shouldFocusError: false,
    defaultValues: { name: '' },
  });

  useEffect(() => {
    if (company) {
      reset({ name: company.name });
    }
  }, [company, reset]);

  const onSubmit = (data: CompanySchema) =>
    onUpdate(companyId!, data, () => navigate('/fleet/companies'));

  if (loadingCompany) {
    return <OrangeLoader />;
  }

  return (
    <form
      onSubmit={handleSubmit(onSubmit)}
      className="w-full max-w-4xl rounded-lg bg-white p-12 shadow-[0_0_4px_rgba(0,0,0,0.1)] flex flex-col gap-6"
    >
      <h2 className="text-2xl font-semibold text-gray-800">Editar compañía</h2>
      <div className="flex flex-col gap-2">
        <label className="text-sm font-medium text-gray-700">Nombre de la compañía</label>
        <FormTextInput
          control={control}
          name="name"
          placeholder="Nombre"
          autoFocus
          required
        />
      </div>
      <div className="flex justify-end gap-3 pt-2">
        <FormCancelButton
          action={() => navigate('/fleet/companies')}
          disabled={isSubmitting}
        />
        <FormSubmitButton
          label={isSubmitting ? 'Guardando...' : 'Guardar cambios'}
          action={handleSubmit(onSubmit)}
          disabled={!isValid}
          isLoading={isSubmitting}
        />
      </div>
    </form>
  );
};

export default EditCompanyForm;